import environment from './set-env';

export function getAuthUrl(isAgent) {
    if (isAgent) {
        return environment.apiAuthAgentUrl;
    }
    return environment.apiAuthCustomerUrl
}
